import { AppDispatch } from 'redux/store';
import { useDispatch } from 'react-redux';
import { useAppSelector } from 'hooks';
import { SavedSearchCriteriaResponse } from 'types/entity';
import { useCallback } from 'react';
import { unwrapResult } from '@reduxjs/toolkit';
import { searchCriteriaReadAction } from './search-criteria-read.slice';
import { searchCriteriaReadQuery } from './search-criteria-read.selector';

export const useSearchCriteriaReadFacade = () => {
  const dispatch: AppDispatch = useDispatch();

  /** 検索条件管理画面から編集中か */
  const inManagement = useAppSelector(searchCriteriaReadQuery.getInManagement);
  /** ロード済みか */
  const loaded = useAppSelector(searchCriteriaReadQuery.getLoaded);
  /** 検索条件一覧 */
  const criterias: SavedSearchCriteriaResponse[] = useAppSelector(searchCriteriaReadQuery.getEntities);

  /** 一覧取得 */
  const loadCriterias = useCallback(
    (projectId: string) => dispatch(searchCriteriaReadAction.loadSearchCriterias(projectId)).then(unwrapResult),
    [dispatch],
  );
  /** 検索条件管理開始 */
  const managementStart = useCallback(
    () => dispatch(searchCriteriaReadAction.managementStart()),
    [dispatch],
  );
  /** 検索条件管理終了 */
  const managementEnd = useCallback(
    () => dispatch(searchCriteriaReadAction.managementEnd()),
    [dispatch],
  );

  return {
    inManagement,
    loaded,
    criterias,
    loadCriterias,
    managementStart,
    managementEnd,
  };
};
